<template>
  <b-container fluid>
    <!-- User Interface controls -->
    <b-row>
      <b-col lg="6" class="my-1">
        <h4>{{ titulo }}</h4>
      </b-col>

      <b-col lg="6" class="my-1">
        <b-form-group
          label="Búsqueda"
          label-for="filter-input"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              id="filter-input"
              v-model="filter"
              type="search"
              placeholder="Escribe palabra que quieras buscar"
            ></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Limpiar</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <!-- Main table element -->
    <b-table
      :items="items"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :filter-included-fields="filterOn"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      :sort-compare="nestedSortCompare"
      stacked="md"
      show-empty
      small
      @filtered="onFiltered"
      empty-text=""
    >

      <template #cell(name)="row">
        {{ row.value.first }} {{ row.value.last }}
      </template>

      <template #cell(actions)="row">
        <b-button size="sm" @click="row.toggleDetails">
          {{ row.detailsShowing ? 'Ocultar' : 'Mostrar' }} Detalle
        </b-button>
      </template>
      <template #row-details="row">
        <b-card>
          <b>Detalle del siniestro {{ row.item.claim_company_reference }}</b>
          <hr>
          <p><b>Descripción: {{ row.item.description }}</b></p>
          <hr>
          <p><b>Última actualización ({{ row.item.last_update_date }}):</b></p>
          <p>{{ row.item.last_update_subject }}</p>
          <b-row>
            <b-col lg="6" class="my-1">
              <b-button size="sm" @click="showClaimLog(row.item)">Ver historial</b-button>
            </b-col>
            <b-col lg="3" class="my-1" v-if="claimIsFinished(row.item)">
            </b-col>
            <b-col lg="3" class="my-1" v-if="claimIsFinished(row.item)" @click="showFileManager(row.item)">
              <b-button size="sm">Mensaje a departamento de siniestros</b-button>
            </b-col>
          </b-row>
        </b-card>
      </template>
    </b-table>
    <center>
      <moon-loader :loading="loadingTable" color="green" size='150px'></moon-loader>
      <br>
    </center>
    <b-row>
      <b-col sm="12" md="12" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="fill"
          size="sm"
          class="my-0"
          first-text="Primera"
          prev-text="Anterior"
          next-text="Siguiente"
          last-text="Última"
        ></b-pagination>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import {policyService} from '@/src/../_services';
import moment from 'moment'
import MoonLoader from 'vue-spinner/src/MoonLoader.vue'


export default {
  name: "RecibosDePoliza",
  components: {
    'MoonLoader': MoonLoader
  },
  props: ['poliza'],
  data() {
    return {
      loadingTable: true,
      invoices: [],
      items: [],
      titulo: "",
      policySelected: {},
      fields: [
        {key: 'numero_recibo', label: 'Recibo N.', sortable: true, sortDirection: 'desc'},
        {key: 'serie', label: 'Serie', sortable: true, class: 'text-center'},
        {key: 'numero_poliza', label: 'Póliza', sortable: true, class: 'text-center'},
        {key: 'compania', label: 'Compañía', sortable: true, class: 'text-center'},
        {key: 'cliente', label: 'Cliente', sortable: true, class: 'text-center'},
        {key: 'nif', label: 'Nif', sortable: true, class: 'text-center'},
        {key: 'fecha_efecto', label: 'Efecto', sortable: true, class: 'text-center'},
        {key: 'fecha_cobro', label: 'Cobro', sortable: true, class: 'text-center'},
        {key: 'fecha_liquidacion', label: 'Liquidación', sortable: true, class: 'text-center'},
        {key: 'importe', label: 'Importe', sortable: true, class: 'text-center'}
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 7,
      pageOptions: [5, 10, 15, {value: 100, text: "Ver todo"}],
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: ''
      }
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return {text: f.label, value: f.key}
        })
    }
  },
  async mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length
    if (this.poliza === undefined || this.poliza === null) {
      this.titulo = "Todos tus recibos pendientes"
      this.misRecibos = await policyService.getPendingInvoices()
    } else {
      this.titulo = "Recibos de la póliza " + this.poliza
      this.misRecibos = await policyService.getInvoicesfromPolicy(this.poliza)
    }
    this.items = policyService.getInvoicesOfPoliciesTable(this.misRecibos)
    this.totalRows = this.items.length
    this.loadingTable = false
  },
  methods: {
    nestedSortCompare(valOne, valTwo, key) {
      switch (key) {
        case 'claim_start_date':
          return moment(valOne, "DD/MM/YYYY") < moment(valTwo, "DD/MM/YYYY")
        default:
          return null;
      }
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    }
  }
}
</script>
<style>
.table {
  font-size: 0.8em !important;
  font-weight: 300;
}

.page-item.active .page-link {
  z-index: 3;
  color: #fff;
  background-color: #8fd19e !important;
  border-color: #8fd19e !important;
}

.page-link {
  position: relative;
  display: block;
  padding: .5rem .75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #1e4827 !important;
  background-color: #fff;
  border: 1px solid #dee2e6;
}
</style>
